import styled from "styled-components";
import { device } from "./Responsive.style.js";

export const FormInput = styled.div`
    position: relative;
    padding: 5px 0;

    input {
        font-size: var(--font-small);
        padding: 8px;
        width: 100%;
        box-sizing: border-box;
        min-width: 300px;
        border: 1px solid var(--dark-bg-hover);
        border-radius: 5px;
        margin: 1px;
        color: var(--text-main);
        background-color: var(--bg-main);
    }

    label {
        color: var(--text-main);
        pointer-events: none;
        position: absolute;
        left: 12px;
        padding: 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: var(--font-small);
        transition: top 0.2s, left 0.2s, font-size 0.2s, padding 0.2s;
    }

    input:focus {
        outline: none; 
        border: 2px solid var(--accent);
        margin: 0px;
    }

    input::placeholder {
        color: var(--text-main);
    }

    input:focus ~ label,
    input:not(:focus):not(:placeholder-shown):not(:-webkit-autofill):invalid ~ label,
    input:not(:focus):not(:placeholder-shown):not(:-webkit-autofill):valid ~ label,
    input:-webkit-autofill ~ label {
        color: var(--accent);
        top: 6px;
        left: 7px;
        background-color: var(--bg-main);
        font-size: 14px;
        padding: 0 5px;
    }
    input:not([type="date"]):not(:focus):not(:placeholder-shown):not(:-webkit-autofill):invalid ~ label {
        color: red;
    }
    input:not([type="date"]):not(:focus):not(:placeholder-shown):not(:-webkit-autofill):invalid {
        border: 2px solid red;
        margin: 0px;
    }
    input:not(:focus):not(:placeholder-shown):not(:-webkit-autofill):valid ~ label,
    input:-webkit-autofill:not(:focus) ~ label {
        color: var(--text-main);
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover, 
    input:-webkit-autofill:focus {
        -webkit-box-shadow: 0 0 0px 1000px white inset;
    }

    input[type="date"] ~ label {
        color: var(--text-main) !important;
    }

    &.textType label, 
    &.textType input ~ label:focus, 
    &.textType input ~ label:active,
    &.textType input:not(:focus):not(:placeholder-shown):not(:-webkit-autofill):invalid ~ label,
    &.textType input:not(:focus):not(:placeholder-shown):not(:-webkit-autofill):valid ~ label,
    &.textType input:-webkit-autofill ~ label{
        top: 15px !important;
        left: 0px !important;
        padding: 0 5px 0 10px !important;
        font-size: 14px;
    }

    @media ${device.small} {
        label {
            color: var(--text-main);
            top: 6px;
            left: 7px;
            background-color: var(--bg-main);
            font-size: 14px;
            padding: 0 5px;
        }
    }
`;

export const Checkbox = styled.label`
    display: block;
    color: var(--text-main);
    position: relative;
    margin: 30px 0 10px;
    padding: 1px 0 0 28px;
    cursor: pointer;
    font-size: var(--font-small);

    input {
        position: absolute;
        opacity: 0;
        height: 0;
        width: 0;
    }

    .customCheckbox {
        position: absolute;
        top: 0;
        left: 0;
        height: 15px;
        width: 15px;
        border: 2px solid var(--accent);
        border-radius: 3px;
    }

    .customCheckbox::after {
        content: "";
        position: absolute;
        display: none;
        left: 5px;
        top: 2px;
        width: 3px;
        height: 7px;
        border: solid var(--accent);
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }

    input:checked ~ .customCheckbox::after {
        display: block;
    }

    input:checked ~ .customCheckbox {
        background-color: #ffe7b5;
    }
`;

export const NormalInput = styled.input`
    box-sizing: border-box;
    font-size: var(--font-small);
    width: 100%;
    padding: 9px 11px;
    border-radius: 5px;
    border: 1px solid var(--dark-bg-hover);
    margin: 2px 0;
    color: var(--text-main);
    background-color: var(--bg-main);

    &:focus {
        outline-color: var(--accent);
    }
`;

export const TextArea = styled.textarea`
    box-sizing: border-box;
    font-size: var(--font-small);
    max-width: 100%;
    min-width: 100%;
    padding: 9px 11px;
    border-radius: 5px;
    border: 1px solid var(--dark-bg-hover);
    margin: 2px 0;
    color: var(--text-main);
    background-color: var(--bg-main);

    &:focus {
        outline-color: var(--accent);
    }
`;

export const NumberInput = styled.input`
    box-sizing: border-box;
    font-size: var(--font-small);
    width: 100px;
    padding: 9px 11px;
    border-radius: 5px;
    border: 1px solid var(--dark-bg-hover);
    margin: 2px 0;
    color: var(--text-main);
    background-color: var(--bg-main);
    display: block;
    outline-color: var(--accent);
`;

export const Dropdown = styled.div`
    width: 100%;
    position: relative;
    z-index: 0;
    padding: 5px 0;

    &::before, &::after {
        --size: 0.3rem;
        content: "";
        position: absolute;
        right: 1rem;
        pointer-events: none;
    }

    &::before {
        border-left: var(--size) solid transparent;
        border-right: var(--size) solid transparent;
        border-bottom: var(--size) solid var(--text-main);
        bottom: 49%;
    } 
    &:has(label)::before {
        bottom: calc(calc(100% - 14px) * 0.46);
    }

    &::after {
        border-left: var(--size) solid transparent;
        border-right: var(--size) solid transparent;
        border-top: var(--size) solid var(--text-main);
        bottom: 33%;
    }
    &:has(label)::after {
        bottom: calc(calc(100% - 14px) * 0.33);
    }

    select {
        appearance: none;
        width: 100%;
        font-size: var(--font-small);
        padding: 8px 95px 8px 8px;
        background-color: var(--bg-main);
        border: 1px solid var(--dark-bg-hover);
        border-radius: 5px;
        color: var(--text-main);
        cursor: pointer;
        height: fit-content;
        max-height: 400px;
        overflow-y: scroll;
    }

    select:focus {
        outline-color: var(--accent);
    }

    label {
        display: block;
        color: var(--text-main);
        font-size: 14px;
        padding: 0 0 5px 0;
    }

    @media ${device.medium} {
        width: 100%;
    }
`;

export const CheckboxDropdownWrapper = styled.div`
    width: 350px;
    position: relative;
    z-index: 3;

    &.dropdown-open {
        z-index: 15;
    }

    @media ${device.small} {
        width: 100%;
    }
`;

export const CheckboxDropdownBtn = styled.button`
    width: 100%;
    text-align: left;
    padding: 10px;
    cursor: pointer;
    background-color: var(--bg-main);
    color: var(--text-main);
    position: relative;
    border: 1px solid var(--dark-bg-hover);
    padding: 10px 95px 10px 16px;
    font-size: var(--font-small);

    &.btnOpen {
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }

    &.btnClose {
        border-radius: 5px;
    }

    &::before, &::after {
        --size: 0.3rem;
        content: "";
        position: absolute;
        right: 1rem;
        pointer-events: none;
    }

    &::before {
        border-left: var(--size) solid transparent;
        border-right: var(--size) solid transparent;
        border-bottom: var(--size) solid var(--text-main);
        top: 40%;
    } 

    &::after {
        border-left: var(--size) solid transparent;
        border-right: var(--size) solid transparent;
        border-top: var(--size) solid var(--text-main);
        top: 55%;
    }
`;

export const CheckboxDropdownOptions = styled.div`
    background-color: var(--bg-main);
    flex-direction: column;
    border-radius: 0 0 5px 5px;
    overflow: hidden;
    border: 1px solid var(--dark-bg-hover);
    border-top: none;
    position: absolute;
    box-sizing: border-box;
    width: 100%;
    height: fit-content;
    max-height: 400px;
    overflow-y: scroll;

    &.closed {
        display: none;
    }

    &.open {
        display: flex;
    }

    input {
        display: none;
    }

    label {
        padding: 5px 5px 5px 15px;
        color: var(--text-main);
        cursor: pointer;
    }

    label:hover {
        background-color: var(--secondary-gray);
    }

    .optionSelected {
        position: relative;
    }

    .optionSelected::before {
        position: absolute;
        content: "";
        height: 90%;
        width: 10px;
        border-radius: 2px;
        left: 0px;
        top: 50%;
        transform: translateY(-50%);
        background-color: var(--accent);
    }
`;